import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';

import { Tabs } from '../components/Tabs';
import { Panels } from '../components/Panels';
import { Users } from '../components/Users';
import { Posts } from '../components/Posts';
import { EnableSquaddedAlert } from '../components/EnableSquaddedAlert';
import { Interactions } from '../components/Interactions';
import { updateAll } from '../_redux/crud';

export function Dashboard() {
	const dispatch = useDispatch();
	const { filter, merchants } = useSelector((state) => state.merchants);

	useEffect(() => {
		if (!filter.merchantId || !filter.to || !filter.from) {
			return;
		}
		updateAll(filter, dispatch);
	}, [filter, dispatch]);

	return (
		<div className='mt-8'>
			{(merchants[0] && merchants[0].shopify) && <EnableSquaddedAlert merchant={merchants[0]} />}
			<Tabs />
			<Panels />
			<Grid container style={{ marginTop: 24 }} wrap='nowrap'>
				<Grid item xs={4} style={{ marginRight: 16 }}>
					<Users />
				</Grid>
				<Grid item xs={4} style={{ marginLeft: 8, marginRight: 8 }}>
					<Posts />
				</Grid>
				<Grid item xs={4} style={{ marginLeft: 16 }}>
					<Interactions />
				</Grid>
			</Grid>
		</div>
	);
}
